const rotuloRemessa = (remessa: string | number): string => {
  const texto = String(remessa).trim();
  const multipla = texto.includes(",");

  return multipla ? `Suas Remessas Nº ${texto}` : `Sua Remessa Nº ${texto}`;
};

// Mensagens padrão por tipo de entrega
const handleMensagensPorTipoRecepcao: Record<
  string,
  (
    nome: string,
    remessa: string | number,
    endereco: string,
    responsavel: string,
    setor: string,
    data_fim_remessa: string
  ) => string
> = {
  balcao: (
    nome,
    remessa,
    _endereco,
    responsavel,
    _setor,
    data_fim_remessa
  ) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} foi retirada no Balcão da Letscom e seu pedido foi concluído.

Responsável pela retirada: ${responsavel}
Data e Hora: ${data_fim_remessa}

Segue anexo o Protocolo de entrega`,

  correios: (nome, remessa, endereco, setor) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} foi enviada pelos correios e seu pedido foi concluído:
${endereco}

Setor: ${setor} 

Qualquer dúvida, entre em contato.
Pedimos a gentileza de acompanhar a entrega no site abaixo, inserindo o número de rastreio:
https://rastreamento.correios.com.br/app/index.php`,

  motoboy_letscom: (
    nome,
    remessa,
    endereco,
    responsavel,
    setor,
    data_fim_remessa
  ) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} foi entregue via motoboy e seu pedido foi concluído.
${endereco}

Setor: ${setor} 
Responsável: ${responsavel}
Data e Hora: ${data_fim_remessa}

Segue anexo o Protocolo de entrega.`,

  outros: (
    nome,
    remessa,
    _endereco,
    responsavel,
    _setor,
    data_fim_remessa
  ) => `Olá ${nome}, tudo bem?
${rotuloRemessa(remessa)} foi retirada no Balcão da Letscom e seu pedido foi concluído. Segue os dados abaixo:

Responsável pela retirada: ${responsavel}
Data e Hora: ${data_fim_remessa}

Segue anexo o comprovante o Protocolo de entrega.`,
};

export { handleMensagensPorTipoRecepcao };
